import Axios from 'axios';
import get from 'lodash/get';

const axiosInstance = Axios.create();

const defaultRefreshService = 'authService';

axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
        const { config } = error;

        if (get(error, 'response.status') === 401 && !config._retry) {
            config._retry = true;

            /**
             *  Yeah, I know that the next line looks like overhead, however,
             *  if we decide to get data from different endpoints (services)
             *  probably it will require different authorization and therefore different ways to refresh the token.
             */
            return import(`~/services/index`)
                .then((module) =>
                    module[config.serviceName || defaultRefreshService].refreshToken()
                )
                .then((token) => axiosInstance(updateAuthorizationHeader(config, token)));
        }

        return Promise.reject(error);
    }
);

const updateAuthorizationHeader = (config, token) => {
    config.headers = {
        ...config.headers,
        Authorization: `Bearer ${token}`,
    };

    return config;
};

const createRequestConfig = ({ token, responseType, onDownloadProgress, baseURL, ...rest }) => {
    if (token) {
        updateAuthorizationHeader(rest, token);
    }

    if (responseType) {
        rest.responseType = responseType;
    }

    if (onDownloadProgress) {
        rest.onDownloadProgress = onDownloadProgress;
    }

    rest.baseURL = baseURL || process.env.REACT_APP_API_BASE_URL;

    return rest;
};

class HttpRestService {
    async get(url, config = {}) {
        return axiosInstance.get(url, createRequestConfig(config));
    }

    async post(url, data = {}, config = {}) {
        return axiosInstance.post(url, data, createRequestConfig(config));
    }

    async patch(url, data = {}, config = {}) {
        return axiosInstance.patch(url, data, createRequestConfig(config));
    }

    async put(url, data = {}, config = {}) {
        return axiosInstance.put(url, data, createRequestConfig(config));
    }

    async delete(url, config = {}) {
        return axiosInstance.delete(url, createRequestConfig(config));
    }
}

export default HttpRestService;
